import { render, staticRenderFns } from "./Shtrek.vue?vue&type=template&id=663979b0"
import script from "./Shtrek.vue?vue&type=script&lang=js"
export * from "./Shtrek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports